import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Copy, Eye, EyeOff, KeyRound } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { ALL_DECKS, deckById } from "./deckRegistry";
import { DeckCards } from "./DeckCards";
import { LinkBuilder } from "./LinkBuilder";
import { SavedLinks } from "./SavedLinks";

const PasswordBox = ({ password, set }) => {
  const [vis, setVis] = useState(false);
  const kopier = () => navigator.clipboard.writeText(password).then(() => toast.success("Passord kopiert")).catch(() => toast.error("Kunne ikke kopiere"));
  return (
    <div className="pdadm-pw" data-testid="pdadm-passord">
      <KeyRound size={14} />
      <span className="k">Felles passord</span>
      <span className="v" data-testid="pdadm-passord-verdi">{set ? (vis ? password : "•".repeat(Math.min(password.length, 14))) : "Ikke satt (DECK_PASSWORD)"}</span>
      {set && (
        <>
          <button type="button" className="ic" onClick={() => setVis((v) => !v)} title={vis ? "Skjul" : "Vis"} data-testid="pdadm-passord-vis">{vis ? <EyeOff size={13} /> : <Eye size={13} />}</button>
          <button type="button" className="ic" onClick={kopier} title="Kopier passord" data-testid="pdadm-passord-kopier"><Copy size={13} /></button>
        </>
      )}
    </div>
  );
};

export default function PartnerDeckAdmin() {
  const [valgt, setValgt] = useState(ALL_DECKS[0].id);
  const [lenker, setLenker] = useState(null);
  const [pw, setPw] = useState({ password: "", set: false });

  const last = useCallback(async () => {
    try {
      const [a, b] = await Promise.all([api.get("/admin/deck-lenker"), api.get("/admin/deck-lenker/passord")]);
      setLenker(a.data.lenker);
      setPw(b.data);
    } catch (e) { toast.error(formatApiError(e)); }
  }, []);
  useEffect(() => { last(); }, [last]);

  const deck = deckById(valgt);

  return (
    <div data-testid="pdadm">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="adm-eyebrow">Decks</p>
          <h1 className="adm-title mt-1">Alle deck. Ett system.</h1>
          <p className="adm-sub mt-1.5 max-w-[60ch]">
            Vision-decket forklarer hva Norwegian AI Summit er; partnerdeckene selger én posisjon hver. Velg deck, skriv inn mottaker —
            den anonyme lenken og PDF-en tilpasser seg automatisk. Samme passord, samme PDF-pipeline.
          </p>
        </div>
        <div className="flex flex-col items-end gap-2">
          <PasswordBox password={pw.password} set={pw.set} />
          <a className="pdadm-hint underline" href={`${process.env.REACT_APP_BACKEND_URL}/api/admin/deck/pdf/health`} target="_blank" rel="noreferrer" data-testid="pdadm-pdf-health">PDF-diagnose (Chromium · minne · print-side)</a>
        </div>
      </div>

      <p className="pdadm-step mt-8"><span>1</span>Velg deck</p>
      <div className="mt-3"><DeckCards valgt={valgt} onSelect={setValgt} /></div>

      <div className="mt-6"><LinkBuilder key={deck.id} deck={deck} password={pw.password} onSaved={last} /></div>

      <SavedLinks lenker={lenker} password={pw.password} onChanged={last} />
    </div>
  );
}
